import { Table } from "antd";

const AlarmsTable = ({
  alarmFilterDetails,
  setAlarmFilterDetails,
  metaData,
}) => {
  const handlePageChange = (pagination, filters) => {
    setAlarmFilterDetails((prev) => ({
      ...prev,
      current: pagination.current,
      pageSize: pagination.pageSize,
      ...filters,
    }));
  };

  const columns = [
    {
      title: "IMEI",
      dataIndex: "imei",
      key: "imei",
      align: "center",
    },
    {
      title: "Name",
      dataIndex: "alarmName",
      key: "alarmName",
      align: "center",
      className: "pl1",
    },
    {
      title: "Count ",
      dataIndex: "alarmCount",
      key: "alarmCount",
      align: "center",
    },
  ];

  return (
    <>
      <Table
        data-testid="system-alarms-table"
        className="system-alarms-table"
        columns={columns}
        dataSource={metaData?.list}
        rowKey={(record, index) => record?.vehicleId + index}
        scroll={{ x: "100%" }}
        onChange={handlePageChange}
        pagination={{
          current: alarmFilterDetails.current,
          pageSize: alarmFilterDetails.pageSize,
          total: metaData?.totalElements,
          showSizeChanger: false,
          showQuickJumper: false,
          hideOnSinglePage: true,
        }}
      />
    </>
  );
};
export default AlarmsTable;
